import { postToServer } from "@/client/utils/postToServer";
import {
    kFetchSpliceSamplesEndpoint,
    type FetchSpliceSamplesSuccessResponse,
} from "@/shared/fetch-splice-samples.api";
import { createErrorMessage } from "@/shared/utils/error";

export interface FetchSpliceSamplesService {
    fetchSamples: (uuids: string[]) => Promise<FetchSpliceSamplesSuccessResponse | Error>;
}

export const createFetchSpliceSamplesService = (): FetchSpliceSamplesService => {
    const fetchSamples = async (
        uuids: string[],
    ): Promise<FetchSpliceSamplesSuccessResponse | Error> => {
        try {
            const result = await postToServer(kFetchSpliceSamplesEndpoint, { uuids });
            if (result instanceof Error) {
                return result;
            }
            return result;
        } catch (error) {
            return new Error(createErrorMessage(error));
        }
    };

    return { fetchSamples };
};
